const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/idea-management/component-gallery.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, notFound } from '@tanstack/react-router';
export const Route = createFileRoute('/(app)/org/$org/idea-management/component-gallery')({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {},
  beforeLoad: ({
    context: {
      flags
    }
  }) => {
    if (!flags.ideaManagerSuiMigrationEnabled) {
      throw notFound();
    }
  }
});